__turbopack_context__.v({
  "bubble": "bdmpopup-module__09N-zW__bubble",
  "gridContainer": "bdmpopup-module__09N-zW__gridContainer",
});
